import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SimpleGlobalModalService, routePath } from '@brightside-web/desktop/data-access/core-services';
import { BrightsideUiModule, HeaderLabelCellConfig } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-credit-error-card',
    templateUrl: './credit-error-card.component.html',
    styleUrls: ['./credit-error-card.component.scss'],
    imports: [BrightsideUiModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('500ms ease-out', style({ opacity: 1 }))])]),
    ]
})
export class CreditErrorCardComponent implements OnInit {
  creditErrorCellConfig: HeaderLabelCellConfig;

  private _router = inject(Router);
  private _translateService = inject(TranslateService);
  private _cdr = inject(ChangeDetectorRef);
  private _modalService = inject(SimpleGlobalModalService);
  
  constructor() { }

  ngOnInit(): void {
    this.showRetryAccessoryCard();
  }

  navigateToCreditSetup(): void {
    this._modalService.createModal({
      title: 'ERROR_CREDIT_LOAD_TITLE'.toUpperCase(),
      contentKey: 'ERROR_CREDIT_LOAD_DESC'.toUpperCase(),
      headerImagePath: './assets/warning-exclamation.png',
      displayCloseButton: true,
      eventName: 'credit_load_failed',
      isError: true,
      size: 'medium',
      ctaKey: 'CLOSE',
      closeAction: () => {
        this._modalService.clearModal();        
      }
    });
  }

  private showRetryAccessoryCard(): void {
    this.creditErrorCellConfig = {
      leftTitle: this._translateService.instant('CREDIT_SCORE'),
      leftTitleSemibold: true,
      bgColor: 'var(--white)',
      minHeight: '2.2rem',
    };
    this._cdr.detectChanges();
  }

}
